import React, {Component} from 'react'
import './Membership.css'
import Loader from '../../components/UI/Loader/Loader';
import Input from '../../components/UI/Input/Input'
import Axios from 'axios';
import Button from '../../components/UI/Button/Button';
import Modal from '../UI/Modal/Modal';
import Notification from '../UI/Notification/Notification';
import Aux from '../../HOC/Auxi';

const FORM_INPUTS = {
    name: {
        label:"Name",
        elemType: "input",
        config: {
            type: 'text', 
            placeholder: "Enter your name please"
        },
        value:"",
        validation: function(){
            let valid = false;
            if(this.value.trim() !== '' && this.value.length >=3 && this.value.length <=30){
                valid = true;
            }
            return valid
        },
        isValid: false, 
        errorMessage: "Name must be up to 3 letters",
        touched: false,
        iconName:"person"
    },
    email: {
        label:"Email",
        elemType: "input",
        config: {
            type: 'text', 
            placeholder: "Email", 
        },
        value:"",
        validation: function(){
            let valid = false;
            const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if(emailRegex.test(this.value)){
                valid = true
            }
            return valid
        },
        isValid: false,
        errorMessage: "Please input a valid email address",
        touched: false,
    },
    reason: {
        label:"Why do you want to join ?",
        elemType: "textarea",
        config: {
            placeholder: "Enter your message",
        },
        value:"",
        validation: function(){
            let valid = false;
            if(this.value.trim() !== '' && this.value.length >=10){
                valid = true;
            }
            return valid
        },
        isValid: false,
        errorMessage: "Please drop a nice message",
        touched: false,
    }
}

class Membership extends Component{
    state= {
        isFormValid: false,
        loading: false,
        isSubmited: false,
        errors: [],
        invalidFormErrorMessage:"Please, fill the forms accurately before you submit",
        formInputs:{
            name: {...FORM_INPUTS.name},
            email:{...FORM_INPUTS.email}, 
            reason: {...FORM_INPUTS.reason}
        },
        notification: {
            show:false,
            data: {
                status: 'primary',
                content: null
            }
        },
    }
    refreshNotification = () => {
        this.setState(state => {
            return{
                ...state, 
                notification: {
                    ...state.notification, 
                    show:false
                }
            }
        })
    }
    formElementChangeHandler = async (event, elemName)=> {
        let formInputs = {...this.state.formInputs}
        let element = formInputs[elemName]
        element.value= event.target.value;
        element.isValid = element.validation()
        element.touched = true;
        await this.setState({formInputs: formInputs})
        await this.checkValidity()
    }
    checkValidity = async()=>{
        let  theFormIsValid = true;
        for(let elemName in this.state.formInputs){
            if(this.state.formInputs[elemName].isValid === false){
                theFormIsValid = false;
                break;
            }
        }
        await this.setState({isFormValid: theFormIsValid})
    }
    onSubmitHandler = async (event)=>{
        let data  = {}
        event.preventDefault();
        await this.setState({isSubmited: true});
        if(this.state.isSubmited && this.state.isFormValid){
            for(let key in this.state.formInputs){
                const deKey= key;
                data[deKey]= this.state.formInputs[deKey].value
            }
            await this.setState({loading: true})
            Axios.post('https://blossomandflourish-backend.herokuapp.com/api/member/add', data)
            .then(res => {
                console.log(res.data)
                const notification = {
                    show: true, 
                    data: {
                        status: 'success', 
                        content: res.data.message
                    }
                }
                this.setState({loading: false,formInputs: {...FORM_INPUTS }, notification})
                this.props.handleModal()
            })
            .catch(err=> {
                if(err.response){
                    console.log(err.message)
                    const notification = {
                        show: true, 
                        data: {
                            status: 'error', 
                            content: err.response.data.message
                        }
                    }
                    this.setState({notification})
                }
            })
            
        }
    }
    render(){
        let formElements = [];
        for(let elementName in this.state.formInputs){
            formElements.push({
                id: elementName, 
                config: this.state.formInputs[elementName]
            })
        }
        let subMitErrorClass = ["ErrorMessage"]
        if(this.state.isSubmited && !this.state.isFormValid){
            subMitErrorClass.push("Show__Error")
        }else{
            subMitErrorClass.push("Hide__Error")
        }
        let toDisplay =  (
            <Button name="Join us now" />
        )
        if(this.state.loading){
            toDisplay = <Loader />
        }
        let displayError = null
        if(this.state.errors.length > 0){
            displayError = this.state.errors.map(err => {
                return (
                    <p className="ErrorMessage"> {err} </p>
                )
            })
        }
        return(
            <Aux>
                <Notification 
                show={this.state.notification.show} 
                data={this.state.notification.data}
                refresh={this.refreshNotification}
                />
                <Modal
                show={this.props.show}
                clicked={this.props.handleModal}
                >
                
                <div className="MembershipForm">
                    <div className="Modal_Close_Icon">
                        <p onClick={this.props.handleModal}><ion-icon name="close"></ion-icon></p>
                    </div>
                    <form onSubmit={this.onSubmitHandler}>
                        {formElements.map(elem => {
                            return(
                                <Input
                                    key={elem.id}
                                    elemType={elem.config.elemType}
                                    config={elem.config.config}
                                    value={elem.config.value}
                                    iconName={elem.config.iconName}
                                    errorMessage={elem.config.errorMessage}
                                    changed={(event)=>this.formElementChangeHandler(event, elem.id)}
                                    valid={elem.config.isValid}
                                    touched={elem.config.touched}
                                    label={elem.config.label}
                                />
                            )
                        })}
                        <div className="LoaderButton">
                            {toDisplay}
                        </div>
                    </form>
                </div>
                </Modal>
            </Aux>
        )
    }
}


export default Membership